import { CUSTOM_CONTRACT_ACTIONS, CustomContractActions, CustomContractState } from './types';

// @ts-ignore
const initialState: CustomContractState = {
  selectedFile: null,
  numPages: null,
  currentPage: 1,
  isEditingPage: false,
  pageInputValue: '1',
  templateName: '',
  fields: [],
};

export const customContractReducer = (state = initialState, action: CustomContractActions): CustomContractState => {
  switch (action.type) {
    case CUSTOM_CONTRACT_ACTIONS.SET_SELECTED_FILE:
      return {
        ...state,
        selectedFile: action.payload,
      };
    case CUSTOM_CONTRACT_ACTIONS.SET_NUM_PAGES:
      return {
        ...state,
        numPages: action.payload,
      };
    case CUSTOM_CONTRACT_ACTIONS.SET_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.payload,
        pageInputValue: action.payload.toString(),
      };
    case CUSTOM_CONTRACT_ACTIONS.SET_IS_EDITING_PAGE:
      return {
        ...state,
        isEditingPage: action.payload,
      };
    case CUSTOM_CONTRACT_ACTIONS.SET_PAGE_INPUT_VALUE:
      return {
        ...state,
        pageInputValue: action.payload,
      };
    case CUSTOM_CONTRACT_ACTIONS.SET_TEMPLATE_NAME:
      return {
        ...state,
        templateName: action.payload,
      };
    case CUSTOM_CONTRACT_ACTIONS.SET_TEMPLATE_FIELDS:
      return {
        ...state,
        fields: action.payload,
      };
    default:
      return state;
  }
};
